import { useSession } from '@components/app/Session';
import { isUnder13 } from '@utils/date-utils';

export const useUserUnder13 = (): boolean => {
    const session = useSession();

    if (!session.user?.birthDate) {
        return true;
    }

    return isUnder13(session.user.birthDate);
};
